const LeadershipMatcher = {
  Media: 'This template is for Media',
  People: 'This template is for People',
};

export default LeadershipMatcher
